export default __webpack_public_path__ + "static/media/app-analysis.8a240936.jpg";